export default "__VITE_ASSET__45c007a7__"